import { InjectionToken } from '@angular/core';

export const MODAL_NAME = new InjectionToken<string>('MODAL_NAME');
